import React from 'react';
import { Toaster } from 'react-hot-toast';
import styles from './Pricing.module.css';
// import CategoryPricing from './CategoryPricing';
import DefaultPricing from './DefaultPricing';

const Pricing = () => (
  <div className={styles.pricing}>
    {/* <CategoryPricing /> */}
    <DefaultPricing />
    <p>
      Post prices are set in your default currency, however if you choose to
      make the paywall visible in only certain countries then the price will be
      quoted in the country’s default currency.
    </p>
    <Toaster
      containerStyle={{
        top: 50,
        left: 20,
        bottom: 20,
        right: 20,
      }}
    />
  </div>
);

export default Pricing;
